import {INCREMENT_TEMP_ID} from "./Types/appStatusTypes";
import {TEMP_ID_PREFIX} from "../../Constants/misc";

export const incrementTempId = () => (dispatch, getState) => {
    dispatch({type: INCREMENT_TEMP_ID});

    // Get updated state after dispatch
    return TEMP_ID_PREFIX + getState().appStatusState.tempId;
};
